(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.alFramePreviewInstalled) return;
  window.alFramePreviewInstalled = true;
  let sequence = 0, pending = false;
  const scenes = [
    { key: 'boho_terracota_40x60cm', base: 'natural', frames: [[338,197,525,464,7],[535,197,719,464,7],[735,197,913,464,7]] },
    { key: 'playa_amanecer_40x60cm', base: 'negro', frames: [[312,197,508,493,6],[530,197,723,493,6],[745,197,939,493,6]] },
    { key: 'bauhaus_blanco_y_negro_40x60cm', base: 'natural', frames: [[330,188,510,470,7],[539,188,715,470,7],[744,188,924,470,7]] },
    { key: 'bohemio_terracota_40x60cm', base: 'negro', frames: [[306,189,506,490,7],[529,188,728,490,7],[751,188,950,490,7]] },
    { key: 'arte_linela_40x60vcm', base: 'natural', frames: [[291,209,491,501,9],[530,210,728,501,9],[766,210,965,501,9]] },
    { key: 'bauhaus_40x60cm', base: 'natural', frames: [[332,244,554,565,6],[580,244,803,567,6],[829,244,1060,568,6]] },
    { key: 'boho_verde_salvia_40x60cm', base: 'natural', frames: [[350,262,520,511,5],[541,262,712,511,5],[734,262,903,511,5]] },
    { key: 'mostaza_y_gris_40x60cm', base: 'natural', frames: [[275,189,490,525,7],[521,189,734,525,7],[764,189,982,525,7]] },
    { key: 'boho_terracota_2025_40x60cm', base: 'blanco', frames: [[337,186,521,472,7],[539,186,724,472,7],[742,186,920,472,7]] },
    { key: 'cactus_terracota_40x60cm', base: 'natural', frames: [[307,191,511,488,7],[529,191,725,488,7],[743,191,947,488,7]] },
    { key: 'boho_terracota_con_medidas', base: 'natural', frames: [[227,167,485,531,8],[506,167,759,531,8],[780,167,1033,531,8]] },
    { key: 'playa_atardecer', base: 'negro', frames: [[229,168,485,531,6],[507,168,759,531,6],[781,168,1033,531,6]] },
    { key: 'bohemio_terracota', base: 'negro', frames: [[228,167,486,531,8],[506,167,759,531,8],[781,166,1033,531,8]] },
    { key: 'arte_lineal', base: 'natural', frames: [[150,168,432,549,10],[487,168,770,549,10],[824,168,1106,549,10]] },
    { key: 'blanco_y_negro', base: 'natural', frames: [[222,140,479,537,8],[503,140,761,537,8],[786,140,1049,537,8]] },
    { key: 'boho_verde_salvia', base: 'natural', frames: [[257,174,488,506,6],[512,174,742,506,6],[770,174,991,506,6]] },
    { key: 'abstracto_mostaza_y_gris', base: 'natural', frames: [[141,172,446,573,8],[473,172,778,573,8],[806,172,1112,573,8]] },
    { key: 'boho_terracota', exclude: 'con_medidas', base: 'blanco', frames: [[227,168,484,530,8],[506,168,759,530,8],[781,168,1033,530,8]] },
    { key: 'cactus_terracota', base: 'natural', frames: [[149,152,453,549,8],[478,152,777,549,8],[805,152,1107,549,8]] },
    { key: 'bauhaus', exclude: 'blanco', base: 'natural', outer: 'M280 243L542 236L543 625L283 619Z M568 235L853 228L850 633L567 626Z M884 227L1197 218L1188 642L881 637Z', inner: 'M287 249L535 243L536 618L290 612Z M575 242L846 235L843 626L574 619Z M891 234L1190 225L1181 635L888 630Z' }
  ];
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const selectionState = new WeakMap();
  const mediaFile = source => String(source || '').split('?')[0].split('/').pop().toLowerCase();
  function syncDesign(gallery, picker) {
    const selected = picker.querySelector('.al-design-picker input:checked');
    const thumb = selected?.closest('.al-design-row')?.querySelector('label img');
    if (!thumb) return;
    const filename = mediaFile(thumb.getAttribute('src'));
    if (!filename) return;
    const previous = selectionState.get(gallery);
    if (previous?.picker === picker && previous.value === selected.value && previous.filename === filename) return;
    const slide = [...gallery.querySelectorAll('.product__media-item')].find(item =>
      [...item.querySelectorAll('.product__media img')].some(image => mediaFile(image.getAttribute('src')) === filename));
    if (!slide || typeof gallery.setActiveMedia !== 'function') return;
    selectionState.set(gallery, { picker, value: selected.value, filename });
    gallery.setActiveMedia(slide.dataset.mediaId, true);
  }
  const resize = new ResizeObserver(() => schedule());
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; update(); });
  }
  function update() {
    document.querySelectorAll('[data-al-frame-gallery]').forEach(marker => {
      const gallery = document.getElementById(marker.dataset.alFrameGallery);
      if (!gallery) return;
      const scope = gallery.closest('product-info') || gallery.closest('.shopify-section');
      if (!scope) return;
      const picker = scope.querySelector('variant-selects');
      if (!picker) return;
      syncDesign(gallery, picker);
      const values = [...picker.querySelectorAll('input:checked, select')].map(el => normalize(el.value));
      const color = values.find(value => ['blanco', 'negro', 'nogal', 'natural'].includes(value));
      const glass = values.some(value => value.includes('vidrio') && !value.includes('sin'));
      gallery.querySelectorAll('.product__media img').forEach(img => {
        const host = img.closest('.product__media');
        const filename = (img.currentSrc || img.src || '').split('?')[0].toLowerCase();
        const scene = scenes.find(item => filename.includes(item.key) && (!item.exclude || !filename.includes(item.exclude)));
        let layer = host.querySelector('.al-frame-layer');
        if (!scene || !color) {
          if (layer) layer.style.display = 'none';
          return;
        }
        if (!img.complete || !img.naturalWidth) return;
        if (layer && layer.dataset.scene !== scene.key) { layer.remove(); layer = null; }
        if (!layer) {
          const id = 'al-frame-' + (++sequence);
          const outer = scene.outer || scene.frames.map(([x,y,r,b]) => `M${x} ${y}H${r}V${b}H${x}Z`).join(' ');
          const inner = scene.inner || scene.frames.map(([x,y,r,b,t]) => `M${x+t} ${y+t}H${r-t}V${b-t}H${x+t}Z`).join(' ');
          const panes = `<path d="${inner}"/>`;
          layer = document.createElement('div');
          layer.dataset.scene = scene.key;
          layer.className = 'al-frame-layer';
          layer.setAttribute('aria-hidden', 'true');
          layer.style.cssText = 'position:absolute;pointer-events:none;overflow:hidden;z-index:2;';
          layer.innerHTML = `<svg viewBox="0 0 1254 1254" width="100%" height="100%" style="display:block"><defs>
          <linearGradient id="${id}-natural"><stop stop-color="#be925c"/><stop offset=".35" stop-color="#e3bf8b"/><stop offset=".65" stop-color="#c69c67"/><stop offset="1" stop-color="#dab481"/></linearGradient>
          <linearGradient id="${id}-wood"><stop stop-color="#553626"/><stop offset=".35" stop-color="#805539"/><stop offset=".65" stop-color="#62402c"/><stop offset="1" stop-color="#946747"/></linearGradient>
          <linearGradient id="${id}-shine" x1="0" y1="0" x2="1" y2="1"><stop stop-color="white" stop-opacity="0"/><stop offset=".35" stop-color="white" stop-opacity=".1"/><stop offset=".44" stop-color="white" stop-opacity=".8"/><stop offset=".58" stop-color="white" stop-opacity=".12"/><stop offset="1" stop-color="white" stop-opacity="0"/></linearGradient>
          <mask id="${id}-rings"><rect width="1254" height="1254" fill="black"/><path d="${outer}" fill="white"/><path d="${inner}" fill="black"/></mask></defs>
          <rect data-rim width="1254" height="1254" mask="url(#${id}-rings)"/>
          <g data-glass fill="url(#${id}-shine)">${panes}</g></svg>`;
          layer.dataset.wood = `url(#${id}-wood)`;
          layer.dataset.natural = `url(#${id}-natural)`;
          if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
          host.appendChild(layer);
          resize.observe(img);
          img.addEventListener('load', schedule);
        }
        layer.style.display = 'block';
        const box = img.getBoundingClientRect(), parent = host.getBoundingClientRect();
        const style = getComputedStyle(img);
        let width = box.width, height = box.height;
        const ratio = img.naturalWidth / img.naturalHeight;
        if (style.objectFit === 'contain' || style.objectFit === 'cover') {
          const scale = Math[style.objectFit === 'cover' ? 'max' : 'min'](box.width / img.naturalWidth, box.height / img.naturalHeight);
          width = img.naturalWidth * scale; height = width / ratio;
        }
        layer.style.left = (box.left - parent.left - host.clientLeft) + 'px';
        layer.style.top = (box.top - parent.top - host.clientTop) + 'px';
        layer.style.width = box.width + 'px'; layer.style.height = box.height + 'px';
        const svg = layer.firstElementChild;
        svg.style.width = width + 'px'; svg.style.height = height + 'px';
        svg.style.marginLeft = ((box.width - width) / 2) + 'px';
        svg.style.marginTop = ((box.height - height) / 2) + 'px';
        const rim = layer.querySelector('[data-rim]');
        rim.setAttribute('fill', color === 'natural' ? layer.dataset.natural : color === 'nogal' ? layer.dataset.wood : color === 'blanco' ? '#f4f1e9' : '#242321');
        rim.setAttribute('opacity', color === scene.base ? '0' : '1');
        layer.querySelector('[data-glass]').setAttribute('opacity', glass ? '.17' : '0');
      });
    });
  }
  let scrollTimer;
  document.addEventListener('change', event => {
    schedule();
    const target = event.target;
    if (!target.closest?.('variant-selects') || !window.matchMedia('(max-width: 749px)').matches) return;
    const value = normalize(target.value);
    if (!['blanco', 'negro', 'nogal', 'natural'].includes(value) && !value.includes('vidrio')) return;
    const scope = target.closest('product-info') || target.closest('.shopify-section');
    const marker = scope?.querySelector('[data-al-frame-gallery]');
    if (!marker) return;
    const galleryId = marker.dataset.alFrameGallery;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      const gallery = document.getElementById(galleryId);
      if (!gallery) return;
      const active = gallery.querySelector('.product__media-item.is-active') || gallery;
      const image = active.querySelector('.product__media img');
      if (!image || !image.getClientRects().length) return;
      const box = image.getBoundingClientRect();
      let topInset = 16;
      document.querySelectorAll('sticky-header, .shopify-section-header').forEach(header => {
        const rect = header.getBoundingClientRect();
        if (rect.top <= 1 && rect.bottom > 0 && rect.bottom < window.innerHeight / 2) topInset = Math.max(topInset, rect.bottom + 12);
      });
      const visible = Math.max(0, Math.min(box.bottom, window.innerHeight) - Math.max(box.top, topInset));
      if (visible >= Math.min(box.height, window.innerHeight - topInset) * .8) return;
      window.scrollTo({ top: Math.max(0, window.scrollY + box.top - topInset), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }, 650);
  });
  customElements.whenDefined('media-gallery').then(schedule);
  document.addEventListener('load', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule);
  new MutationObserver(records => {
    if (records.some(record => !record.target.closest?.('.al-frame-layer'))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
